export default __webpack_public_path__ + "media/7b60b542c2bf0ed4661216f830b666dbcd9d512c9349d74a0a8e5ad13fb0ca84.svg";